import httpClient from './httpClient';

export type ClientSecretResponse = {
    clientId: string;
    clientSecret: string;
};

export const getClientSecret = async (): Promise<ClientSecretResponse> => {
    // Mocking response since backend GET /api/v1/client-secret might be missing
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve({
                clientId: 'ab881e45-b146-4b2b-978a-ab75b3876cb5',
                clientSecret: '', // Initial secret empty as requested
            });
        }, 500);
    });
    // const { data } = await httpClient.get<ClientSecretResponse>('/api/v1/client-secret');
    // return data;
};

export const regenerateClientSecret = async (): Promise<ClientSecretResponse> => {
    const { data } = await httpClient.post<ClientSecretResponse>('/api/v1/client-secret'); // Fixed endpoint
    return data;
};
